import { toFixed, unformat } from 'accounting-js';

const formatter = options =>
  new Intl.NumberFormat(options.locale || 'en-US', {
    ...options,
    style: options.style || 'currency',
    currency: options.currency || 'usd',
    minimumFractionDigits: options.minimumFractionDigits || 0,
  });

export const unformatAmountToCents = (amount, currency) => {
  switch (currency) {
    case 'jpy':
    case 'clp':
      return unformat(amount);
    default:
      return unformat(amount) * 100;
  }
};

export const formatCentsToDecimals = (amount, currency) => {
  switch (currency) {
    case 'jpy':
    case 'clp':
      return toFixed(amount);
    default:
      return toFixed(amount / 100);
  }
};

const currencyFormatter = ({ locale, amount, currency, style, minimumFractionDigits, ...rest }) => {
  switch (currency) {
    case 'jpy':
    case 'clp':
      return formatter({
        locale,
        currency,
        style,
        minimumFractionDigits: minimumFractionDigits || 0,
        ...rest,
      }).format(amount);
    default: {
      return formatter({
        locale,
        currency,
        style,
        minimumFractionDigits: minimumFractionDigits >= 0 ? minimumFractionDigits : 2,
        trailingZeroDisplay: 'stripIfInteger',
        ...rest,
      }).format(toFixed(amount / 100));
    }
  }
};

export function formatPrice({ locale, amount, currency, style, minimumFractionDigits, ...rest }) {
  let amountToFormat = amount;
  if (!amount) amountToFormat = 0;

  const formattedAmount = currencyFormatter({
    amount: Number(amountToFormat),
    locale,
    currency,
    style,
    minimumFractionDigits,
    ...rest,
  });

  return formattedAmount;
}

export function formatPriceInput(price, currency = 'usd') {
  if (!price) return 0;

  let amount = price;

  if (typeof amount !== 'number') {
    amount = amount.replace(/,/g, '.').replace(/[.](?=.*[.])/g, '');
  }

  amount = unformatAmountToCents(amount, currency);

  const amountFixed = amount.toFixed(0);

  return amountFixed;
}
